module.exports = "pegasus_template/assets/themelp1/travel/108.png";